<template lang="pug">
  div.InputNotification(:class="`InputNotification--${type}`")
    i.Icon.IconError(v-if="type === 'error'")
    slot
</template>

<script>
export default {
  name: 'input-notification',
  props: {
    type: {
      type: String,
      default: 'error'
    }
  }
}
</script>

<style scoped lang="scss">
@import '~base';
.InputNotification {
  padding: 5px 0;

  &--error {
    color: var(--errorColor);

    .Icon {
      margin-right: 5px;
      font-size: 12px;
      vertical-align: baseline;
    }
  }

  &--warning {
    color: var(--warningColor);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InputNotification.vue